// extracted by mini-css-extract-plugin
export default {"body":"LandingPage_body__iQDNo","fadein":"LandingPage_fadein__SDydk"};